type CookieOptions = {
    days?: number;
    path?: string;
    sameSite?: "Strict" | "Lax" | "None";
    secure?: boolean;
    domain?: string;
};

export function setCookie(
    name: string,
    value: string,
    {
        days,
        path = "/",
        sameSite = "Lax",
        secure,
        domain,
    }: CookieOptions = {}
) {
    const parts = [
        `${encodeURIComponent(name)}=${encodeURIComponent(value)}`,
        `Path=${path}`,
        `SameSite=${sameSite}`,
    ];

    if (domain) {
        parts.push(`Domain=${domain}`);
    }

    if (secure) {
        parts.push("Secure");
    }

    if (days != null) {
        const expires = new Date(Date.now() + days * 864e5);

        parts.push(
            `Expires=${expires.toUTCString()}`,
            `Max-Age=${days * 86400}`
        );
    }

    document.cookie = parts.join("; ");
}

export function getCookie(name: string): string | null {
    const key = `${encodeURIComponent(name)}=`;

    const hit = document.cookie
        .split("; ")
        .find(row => row.startsWith(key));

    if (!hit) return null;

    return decodeURIComponent(hit.slice(key.length));
}

export function readJSONCookie<T>(name: string, fallback: T): T {
    const raw = getCookie(name);

    if (!raw) return fallback;

    try {
        return JSON.parse(raw) as T;
    } catch {
        return fallback;
    }
}

export function writeJSONCookie(
    name: string,
    value: unknown,
    options?: CookieOptions
) {
    setCookie(name, JSON.stringify(value), options);
}

export function deleteCookie(
    name: string,
    {
        path = "/",
        sameSite = "Lax",
        secure,
        domain,
    }: Omit<CookieOptions, "days"> = {}
) {
    setCookie(name, "", {
        days: -1,
        path,
        sameSite,
        secure,
        domain,
    });
}